module.exports = __webpack_public_path__ + "static/media/secure_family_fisdom.a366a692.svg";